
import * as React from 'react';
import { useState, useMemo } from 'react';
import PropTypes from 'prop-types';

// REACT DATA TABLE COMPONENT
import DataTable from "react-data-table-component";
import FilterComponent from "./FilterComponent";
import { customStyles } from '../styles/tableTemplatesStyles'


const FilteredDataTable = ( props ) => {

    const { title, columns, data, dense } = props;     
    
    // REACT STATES
	const [filterText, setFilterText] = useState('');
	const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    const filteredItems = data.filter(
        item =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

	const subHeaderComponentMemo = useMemo(() => {
		const handleClear = () => {
			if (filterText) {
				setResetPaginationToggle(!resetPaginationToggle);
				setFilterText('');
			}
		};

		return (
			<FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
		);
	}, [filterText, resetPaginationToggle]);

    if(title) {
        return(  
                <DataTable
                    title={title}
                    columns={columns}
                    data={filteredItems}
                    customStyles={customStyles}
                    striped
                    responsive
                    pagination
                    paginationResetDefaultPage={resetPaginationToggle} 
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                    //conditionalRowStyles={conditionalRowStyles}
                    persistTableHead
                    dense={dense}
                />
            );
    } else {
        return (
            <DataTable
                columns={columns}
                data={filteredItems}
                customStyles={customStyles}
                striped
                responsive
                pagination
                paginationResetDefaultPage={resetPaginationToggle} 
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
                //conditionalRowStyles={conditionalRowStyles}
                persistTableHead
                dense={dense}
            />
        );
    }
   
};

export default FilteredDataTable;

FilteredDataTable.defaultProps = {
    dense: false,
};

FilteredDataTable.propTypes = {
    title: PropTypes.node.isRequired,
    data: PropTypes.array.isRequired,
    columns: PropTypes.array.isRequired,
    dense: PropTypes.bool,
};